<div class="component-container">
  <div *ngIf="!editing;else edit" (click)="onTextClicked()" class="text-container" title="Click to edit">
    <span class="text-container__text">{{data}}</span>
    <i class="material-icons text-container__edit">edit</i>
  </div>
  <ng-template #edit>
    <div class="input-container" [class.input-container--right]="alignRight">
      <input class="input-container__input" #dataInput type="text" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow />
      <div class="input-container__buttons">
        <div class="save-button" title="Save Changes" (click)="onSaveClicked(dataInput.value)">
          <i class="material-icons save-button__icon">check</i>
        </div>
        <div class="cancel-button" title="Cancel" (click)="onCancelClicked()">
          <i class="material-icons cancel-button__icon">close</i>
        </div>
      </div>
    </div>
  </ng-template>
</div>
